import { render } from "./BreedsView.vue?vue&type=template&id=31197168&scoped=true"
import script from "./BreedsView.vue?vue&type=script&lang=js"
export * from "./BreedsView.vue?vue&type=script&lang=js"

import "./BreedsView.vue?vue&type=style&index=0&id=31197168&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31197168"]])

export default __exports__